import React from 'react';
import './radioList.scss';
import { IRadioItem } from '@umu/umu-types';

interface IProps {
    list: IRadioItem[];
    checked: number | string;
    onChange: (data: IRadioItem) => void;
}

export function RadioList({ list, checked, onChange }: IProps) {
    const handleCheck = (data: IRadioItem) => {
        if (data.disabled) {
            return;
        }
        if (onChange) {
            onChange(data);
        }
    };

    return (
        <div className="radio-list">
            {list.map((item) => {
                const cls = `radio-box ${checked === item.value && 'checked'} ${!!item.disabled && 'disabled'}`;

                const radioBox = (
                    <div
                        key={item.value}
                        className={cls}
                        onClick={() => {
                            handleCheck(item);
                        }}
                    >
                        <span className="input-block"></span>
                        <label htmlFor="">{item.label}</label>
                    </div>
                );
                return radioBox;
            })}
        </div>
    );
}
